module.exports = __webpack_public_path__ + "fonts/MTSWide-Black.c5cd170.woff2";